const envs = ['sandbox', 'development', 'qa', 'production'] as const;

export type Env = (typeof envs)[number];

export function getEnv(): Env {
  const env = envs.includes(import.meta?.env?.MODE as Env) ? import.meta.env.MODE : 'production';

  return env as Env;
}
